import {
  WebSocketEditNotification,
  WebSocketEditNotificationElement,
  WebSocketEditNotificationStatus,
} from '@agroone/entities'
import { Injectable } from '@angular/core'
import { BehaviorSubject, map, Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class WebSocketStateService {
  public readonly elementsSubject: BehaviorSubject<WebSocketEditNotification[]> = new BehaviorSubject<
    WebSocketEditNotification[]
  >([])
  public readonly elements$: Observable<WebSocketEditNotification[]> = this.elementsSubject.asObservable()

  isEditing(
    elementId: string | undefined,
    elementType: WebSocketEditNotificationElement,
  ): Observable<WebSocketEditNotification | undefined> {
    return this.elements$.pipe(
      map((elements: WebSocketEditNotification[]) => {
        const element: WebSocketEditNotification | undefined = elements.find(
          (element: WebSocketEditNotification) =>
            element.elementId === elementId && element.elementType === elementType,
        )

        return element?.status === WebSocketEditNotificationStatus.EDITING ? element : undefined
      }),
    )
  }

  setMultipleEditingStatus(notifications: WebSocketEditNotification[]): void {
    const currentElements: WebSocketEditNotification[] = this.elementsSubject.getValue()
    const updatedElements: WebSocketEditNotification[] = [...currentElements]

    notifications.forEach((notification) => {
      const existingElementIndex: number = updatedElements.findIndex(
        (element) => element.elementId === notification.elementId && element.elementType === notification.elementType,
      )

      if (existingElementIndex >= 0) {
        updatedElements[existingElementIndex] = {
          ...updatedElements[existingElementIndex],
          status: notification.status,
          force: notification.status === WebSocketEditNotificationStatus.EDITING ? notification.force : false,
          userDetails: notification.userDetails,
        }
      } else {
        updatedElements.push(notification)
      }
    })

    this.elementsSubject.next(updatedElements)
  }
}
